// extracted by mini-css-extract-plugin
module.exports = {"root":"NativeSelect_root__1KgPF","error":"NativeSelect_error__NHzCI","arrow":"NativeSelect_arrow__39dzY","option":"NativeSelect_option__2ysLD"};